<template>
    <th>
        <div>{{ node.dateStart }}</div>
        <div>{{ node.dateEnd }}</div>
        <div class="ghost" v-if="$parent.scrollTop > 50">
            <div>{{ node.dateEnd }}</div>
        </div>
    </th>
</template>

<script>
export default {
    name: 'FsHead',
    props: ['node','index'],
}
</script>

<style>
.ghost {
    color: rgba(0,0,255,.75);
    position: absolute;
}
.ghost > div {
    margin: 0;
    padding: 0;
    position: relative;
    left: 47%;
    top: -48px;
    z-index: 1;
}
</style>